import * as angular from "angular";
import {IController} from "angular";

export class PlanningResourcesChipsDisplayCtrl implements IController {
  list: any;
  onRemove: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningResourcesChipsDisplay', {
    bindings: {
      list: '<',
      onRemove: '&'
    },
    template: require('./planning-resources-chips-display.html').default,
    controller: PlanningResourcesChipsDisplayCtrl
  });
